module.exports = __webpack_public_path__ + "static/media/CTLI_14-444w.091e66a3.png";